<div class="container">
    <google-chart (mousemove)="onMouseMove($event)" (mouseleave)="onMouseLeave()" [data]="chartData"></google-chart>
    <div [class]="showTooltip ? 'values show-tooltip' : 'values'">
      <div class="gebruik">{{showTooltip ? gebruikOpPunt : (viewModel.onGetGemiddeldGebruik | async)}}</div>
      <div class="tooltip">{{tooltip}}</div>
    </div>
  </div>